angular.module('zc.projects')

.controller 'EditCampaignCtrl', (
  $state,
  $scope,
  Campaign,
  InterestWidget,
  campaign,
  configurationTypes,
  currentProject,
  incentives,
  pageTypes,
  templates,
) ->
  $scope.campaign = campaign
  $scope.currentProject = currentProject
  $scope.templates = templates
  $scope.incentives = incentives
  $scope.InterestWidget = InterestWidget
  $scope.configurationTypes = configurationTypes
  $scope.$state = $state
  $scope.pageTypes = pageTypes

  $scope.showsExitPreventionNotification = false

  $scope.handleSave = (campaign) ->
    if campaign
      oldCampaign = angular.extend({}, $scope.campaign)
      $scope.campaign = campaign
      $scope.handleSaveForInterestWidget(oldCampaign)
      if $scope.campaign.template_type
        $scope.campaign.template = _.find $scope.templates,
          name: $scope.campaign.template_type
      if $scope.campaign.segment_id
        $scope.campaign.segment = _.find $scope.campaign_segments,
          id: $scope.campaign.segment_id

  $scope.handleSaveForInterestWidget = (oldCampaign) ->
    InterestWidget.all(currentProject.apikey)
    .then (interestWidgets) ->
      interestWidget = _.find(interestWidgets, (iw) -> (iw.campaign.id is $scope.campaign.id))

      if oldCampaign.delivery_type_option.id == 'ab_delivery'
        if interestWidget
          InterestWidget.remove(currentProject.apikey, interestWidget.id)
          .then (res) ->
            delete $scope.campaign.interest_widget_id
            delete $scope.campaign.delivery_type_option
            InterestWidget.updateCampaignWithInterestWidget($scope.campaign)
        else
          InterestWidget.updateCampaignWithInterestWidget($scope.campaign)
      else
        if !interestWidget
          interestWidget = {
            name: $scope.campaign.name
            campaign_id: $scope.campaign.id
            status: 'incomplete_setting'
          }
          InterestWidget.create(currentProject.apikey, interestWidget)
          .then (res) ->
            $scope.campaign.interest_widget_id = res.id
            delete $scope.campaign.delivery_type_option
            $scope.campaign.iw_status = 'incomplete_setting'
            InterestWidget.updateCampaignWithInterestWidget($scope.campaign)
        else
          InterestWidget.updateCampaignWithInterestWidget($scope.campaign)

  $scope.updateCanSaveCampaign = ->
    $scope.canSaveCampaign = switch $scope.campaign.status
                               when 'incomplete'
                                 true
                               when 'preview'
                                 $scope.templateForm?.$valid
                               when 'activated', 'blocked', 'terminated'
                                 $scope.allValid
                               else
                                 throw "Unknown status! #{$scope.campaign.status}"

  $scope.saveCampaign = ->
    # saving should be possible to do anytime, so no validation required
    Campaign.update {
      projectId: $state.params.projectId
      campaignId: $scope.campaign.id
    }, $scope.campaign
    .then (res) ->
      $scope.handleSave res.campaign

  $scope.saveCampaignAndReturn = ->
    # saving should be possible to do anytime, so no validation required
    $scope.saveCampaign()
    .then returnToCampaigns

  $scope.changeStatus = (status) ->
    Campaign.update {
      projectId: $state.params.projectId
      campaignId: $scope.campaign.id
    }, _.assignIn({}, $scope.campaign, {status})
    .then (res) ->
      $scope.handleSave res.campaign
    .then returnToCampaigns

  $scope.changeInterestWidgetStatus = (status) ->
    unless status in ['incomplete_setting', 'preview', 'enable']
      alertify.error "Unknown status! #{status}"
      return
    InterestWidget.all(currentProject.apikey)
    .then (interestWidgets) ->
      interestWidget = _.find(interestWidgets, (iw) -> (iw.campaign.id is $scope.campaign.id))
      interestWidget.status = status
      InterestWidget.update(currentProject.apikey, interestWidget.id, interestWidget)
      .then returnToCampaigns

  returnToCampaigns = ->
    $state.go "admin.projects.campaigns.list",
      projectId: $state.params.projectId
    ,
      reload: true

  $scope.$watchGroup [
    'campaign.campaign_control_percent'
    'campaign.segment.conditions_json.triggers'
  ], ([control_percent, triggers]) ->
    triggers or= []
    $scope.showsExitPreventionNotification = control_percent >= 1 and 'history_back' in triggers

  $scope.$watchGroup [
    'basicForm.$valid'
    'templateForm.$valid'
    'incentiveForm.$valid'
    'policyForm.$valid'
    'botbonnieForm.$valid'
    'timingForm.$valid'
    'scheduleForm.$valid'
  ], ([basicFormValid, templateFormValid, incentiveForm, policyFormValid, botbonnieFormValid, timingFormValid, scheduleFormValid]) ->
    $scope.allValid = basicFormValid and templateFormValid and incentiveForm and policyFormValid and botbonnieFormValid and timingFormValid and scheduleFormValid

    $scope.updateCanSaveCampaign()

  $scope.$on '$stateChangeSuccess', ->
    # Go to to the proper state
    if $state.current.name == 'admin.projects.campaigns.edit'
      $state.go('admin.projects.campaigns.edit.base')



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/edit.controller.js.coffee